<template>
  <div>
    <Button type="primary" @click="handleEdit(0)">添加banner</Button>

    <Table ref="selection" :columns="columns" :data="tableData" class="mt20" :loading="tableLoading"></Table>
    <Modal
      v-model.trim="modalVisibile"
      width="1120"
      :title="modalTitle"
      :mask-closable="false"
      :loading="modalLoading"
      @on-cancel="handleCancel"
    >
      <el-scrollbar wrapClass="appMoticeScroll">
        <Form @submit.native.prevent ref="form" inline :model="modalForm" label-position="top">
          <FormItem label="banner封面 (750px*232px)" prop="imgUrl">
            <Upload
              ref="upload"
              :show-upload-list="false"
              :default-file-list="defaultList"
              :on-success="handleSuccess"
              :format="['jpg','jpeg','png']"
              :max-size="2048"
              :on-format-error="handleFormatError"
              :on-exceeded-size="handleMaxSize"
              :before-upload="beforeImgUpload"
              multiple
              type="drag"
              action
              style="display: inline-block;width:58px;"
            >
              <div style="width: 400px;min-height:200px;">
                <img class="modal_pic" v-if="poster" :src="poster" alt="头像" />
                <Icon type="ios-camera" size="20"></Icon>
              </div>
            </Upload>
            <!-- <img-upload :imgUrl="modalForm.imgUrl" @change="handleImgChange"></img-upload> -->
          </FormItem>
          <div class="w280 ml20" style="display:inline-block;">
            <!-- <div>
              <FormItem label="标题" prop="title">
                <Input class="w280" type="text" v-model.trim="modalForm.title" placeholder="请输入标题" />
              </FormItem>
            </div>-->

            <div class="w280">
              <FormItem label="序号" prop="sort" style="margin-left:230px;">
                <Input
                  class="w280"
                  type="number"
                  v-model.trim="modalForm.sort"
                  placeholder="请输入序号"
                />
              </FormItem>
            </div>
          </div>
          <FormItem label="公告内容">
            <editor
              ref="editor"
              @on-change="handleEditorChange"
              :value="modalForm.content"
              showUser
              showArticle
              style="width:1024px"
            />
          </FormItem>
        </Form>
      </el-scrollbar>
      <div slot="footer">
        <Button @click="handleCancel">取消</Button>
        <Button
          type="primary"
          @click="handleUpdate"
          :loading="modalLoading"
          :disabled="modalLoading"
        >确定</Button>
      </div>
    </Modal>

    <!-- <div class="top clearfix">
      <p style="padding-bottom:10px;">banner封面 (1920px*596px)</p>
      <Spin fix v-show="imgLoading"></Spin>
      <Upload
        ref="upload"
        :show-upload-list="false"
        :default-file-list="defaultList"
        :on-success="handleSuccess"
        :format="['jpg','jpeg','png']"
        :max-size="2048"
        :on-format-error="handleFormatError"
        :on-exceeded-size="handleMaxSize"
        :before-upload="beforeImgUpload"
        multiple
        type="drag"
        action
        style="display: inline-block;width:58px;"
      >
        <div style="width: 700px;min-height:200px;">
          <img class="modal_pic" v-if="poster" :src="poster" alt="头像" />
          <Icon type="ios-camera" size="20"></Icon>
        </div>
      </Upload>

    </div>
    <div class="pic_wrap">   
      <editor
        ref="editor"
        :value="content"
        showUser
        showArticle
        @on-change="handleEditorChange"
        style="width: 1200px;height: 500px;"
      />

      <div class="clearfix">
        <Button type="primary" class="fr" :loading="addLoading" @click="handleUpdate">保存</Button>
        <Button type="primary" class="fr delBtn" @click="contDel" style="background:#ff5579;border:1px solid #ff5579;margin-right:10px;">删除</Button>
      </div>
    </div>-->
  </div>
</template>

<script>
import * as qiniu from "qiniu-js";
import mixins from "@/mixins/page";
import Editor from "_c/editor";
// import imgUpload from '@/components/imgUpload'
export default {
  name: "index_banner",
  mixins: [mixins],
  components: {
    Editor
    // imgUpload
  },
  data() {
    return {
      modalTitle: "编辑banner",
      modalForm: {},
      tableData: [],
      content: "",
      modalVisibile: false,
      modalLoading: false,
      addLoading: false,
      posterList: [],
      defaultList: [],
      imgName: "",
      visible: false,
      uploadList: [],
      viewImg: "",
      addDisable: false,
      page_size: 155,
      tableLoading: false,
      imgLoading: false,
      poster: "",
      columns: [
        // {
        //   title: '标题',
        //   key: 'title'
        // },
        {
          title: "封面",
          key: "pic",
          Width: 100,
          render: (h, params) => {
            return params.row.poster
              ? h("img", {
                  class: {
                    table_pic: true
                  },
                  domProps: {
                    src: params.row.poster,
                    alt: "头像"
                  },
                  on: {
                    click: () => this.$pic.init([params.row.poster])
                  }
                })
              : null;
          }
        },
        {
          title: "排序",
          key: "sort"
        },
        // {
        //   title: '类别',
        //   key: 'redirectType',
        //   render: (h, params) => {
        //     return params.row.redirectType ? h('span', '文章') : h('span', '自定义')
        //   }
        // },

        {
          title: "操作",
          key: "name",
          render: (h, params) => {
            // 剩下一条时没有删除
            var length = this.tableData.length===1?false:true;
            return h("div", [
              h(
                "span",
                {
                  class: {
                    btn_edit: true
                  },
                  on: {
                    click: () => this.handleEdit(params)
                  }
                },
                "编辑"
              ),
              length &&
                h("i", {
                  class: {
                    sline: true
                  }
                }),
              length &&
                h(
                  "span",
                  {
                    class: {
                      btn_del: true
                    },
                    on: {
                      click: () => this.contDel(params.row.id)
                    }
                  },
                  "删除"
                )
            ]);
          }
        }
      ]
    };
  },
  mounted() {
    // this.uploadList = this.$refs.upload.fileList;
    this.handleQuery();
  },
  methods: {
    handleEdit(params) {
      if (params) {
        this.modalTitle = "编辑banner";
        this.modalForm.sort = params.row.sort;
        this.poster = params.row.poster;
        this.content = params.row.content;
        this.$refs.editor.setHtml(params.row.content);
        this.id = params.row.id;
      } else {
        this.modalTitle = "添加banner";
        this.$refs.editor.setHtml("");
      }
      this.modalVisibile = true;
    },
    // 上传图片
    handleImgChange(data) {
      this.modalForm.imgUrl = data;
    },
    handleCancel() {
      this.modalVisibile = false;
      this.poster = "";
     this.modalForm.sort=''
    },
    handleUpdate() {    
      if(!this.poster||!this.content||this.modalForm.sort===''){
         this.$Message.warning('不可为空，请检查');
         return
      }
      this.modalLoading=true;
      if (this.modalTitle === "编辑banner") {
        this.$api
          .updateBanner({
            id: this.id,
            poster: this.poster,
            content: this.content,
            sort: this.modalForm.sort
          })
          .then(res => {
            if (res.code === 0) {
              this.$Message.success(res.msg);
              this.tableLoading = false;
               this.modalLoading=false;
              this.handleCancel();
              this.handleQuery();
            } else {
              this.$Message.error(res.msg);
            }
            // this.addLoding = false;
          });
      } else {
        //添加banner
        this.$api
          .addBanner({          
            poster: this.poster,
            content: this.content,
            sort: this.modalForm.sort
          })
          .then(res => {
            if (res.code === 0) {
              this.$Message.success(res.msg);
              this.tableLoading = false;
               this.modalLoading=false;

              this.handleCancel();
              this.handleQuery();
            } else {
              this.$Message.error(res.msg);
            }
            // this.addLoding = false;
          });
      }
    },
    handleView(item) {
      this.visible = true;
      this.viewImg = item.url;
    },
    handleRemove(file) {
      const fileList = this.$refs.upload.fileList;
      this.$refs.upload.fileList.splice(fileList.indexOf(file), 1);
    },
    handleSuccess(res, file) {
      file.url =
        "https://o5wwk8baw.qnssl.com/7eb99afb9d5f317c912f08b5212fd69a/avatar";
      file.name = "7eb99afb9d5f317c912f08b5212fd69a";
    },
    handleFormatError(file) {
      this.$Notice.warning({
        title: "The file format is incorrect",
        desc:
          "File format of " +
          file.name +
          " is incorrect, please select jpg or png."
      });
    },
    handleMaxSize(file) {
      this.$Notice.warning({
        title: "Exceeding file size limit",
        desc: "File  " + file.name + " is too large, no more than 2M."
      });
    },
    handleBeforeUpload() {
      const check = this.uploadList.length < 15;
      if (!check) {
        this.$Notice.warning({
          title: "Up to five pictures can be uploaded."
        });
      }
      return check;
    },
    //上传图片
    beforeImgUpload(file) {
      let that = this;
      this.imgLoading = true;
      // 从后台获取token和key
      this.$api.getQiToken({}).then(res => {
        if (res.code === 0) {
          let key = res.data.key;
          let token = res.data.QiNiuToken;
          let config = {
            useCdnDomain: true,
            region: null
          };
          let putExtra = {
            fname: "",
            params: {},
            mimeType: null
          };
          let observable = qiniu.upload(file, key, token, putExtra, config);
          observable.subscribe({
            error: function(err) {
              this.$Message.success(err);
              this.imgLoading = false;
            },
            complete: function(res) {
              that.$api.getImgPath({ key: res.key }).then(res => {
                if (res.code === 0) {
                  that.poster = res.msg;
                  that.imgLoading = false;
                  //传递后台
                }
              });
            }
          });
        } else {
          this.$Message.error(res.msg);
          this.imgLoading = false;
        }
      });
      return false;
    },

    handleQuery() {
      this.page_num = 1;
      this.getTableData();
    },
    getTableData() {
      // this.$refs.editor.setHtml('')
      this.tableLoading = true;
      this.$api
        .getBannerList({ page_num: this.page_num, page_size: this.page_size })
        .then(res => {
          if (res.code === 0) {
            this.tableData = res.data.list;
            // this.poster=res.data.list[0].poster
            // this.total = res.data.total_row;
            // this.content = res.data.list[0].content
            // this.id = res.data.list[0].id
             this.tableLoading = false;
            // this.$refs.editor.setHtml(res.data.list[0].content)
          } else {
            this.$Message.error(res.msg);
          }
        });
    },
    handleRemovePoster(item) {
      let param = {
        id: item.id
      };
      this.$api.delBanner(param).then(res => {
        if (res.code === 0) {
          this.$Message.success(res.msg);
          this.getTableData();
        } else {
          this.$Message.error(res.msg);
        }
      });
    },
    handleEditorChange(val) {
      this.content = val;
    },
    //保存内容
    contSave() {
      this.addLoading = true;
    },
    contDel(id) {
      this.$Modal.confirm({
        render: h => {
          return h("div", [
            h(
              "div",
              {
                class: {
                  modal_icon_del: true
                }
              },
              "banner删除"
            ),
            h(
              "div",
              {
                class: {
                  modal_text: true
                }
              },
              "确定删除此条banner吗?"
            )
          ]);
        },
        onOk: () => {
          console.log(id)
          this.$api.delBanner({ id: id }).then(res => {
            this.$Message.success("删除成功");
            this.getTableData();
          });
        }
      });
      // this.content = "";
      // this.$refs.editor.setHtml("");
    }
  }
};
</script>

<style scoped lang="less">
.mt18 {
  margin-top: 18px;
}
/deep/.w-e-text-container {
  height: 446px !important;
}
.top {
  padding-bottom: 15px;
}
.demo-upload-list,
.demo-upload-list-wrap {
  display: inline-block;
  width: 60px;
  height: 60px;
  text-align: center;
  line-height: 60px;
  border: 1px solid transparent;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  position: relative;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
  margin-right: 4px;
}
.demo-upload-list-wrap {
  border: none;
  width: 800px;
  height: auto;
  margin: 5px 5px;
  box-shadow: none;
}
.demo-upload-list img {
  width: 100%;
  height: 100%;
  display: block;
}
.demo-upload-list-cover {
  display: none;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.6);
}
.demo-upload-list:hover .demo-upload-list-cover {
  display: flex;
}
.demo-upload-list-cover i {
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  margin: 0 2px;
}
.demo-upload-list-wrap .demo-upload-list-cover {
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  /*margin: 0 2px;*/
  display: none;
  align-items: center;
  justify-content: center;
}
.pic_wrap {
  padding-top: 15px;
  position: relative;
}
/deep/ .ivu-upload-drag {
  width: 400px;
  height: 200px;
}
.modal_pic {
  width: 400px;
  height: 200px;
  // height: auto;
  display: block;
}
/deep/ .ivu-icon-ios-camera {
  position: absolute;
  z-index: 999;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

/deep/ .table_pic {
  width: 40px;
  height: 40px;
  border-radius: 100%;
  display: block;
  cursor: pointer;
}
</style>
